import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import SimpleSearch from '../../components/Search/SimpleSearch';
import { GetMainPage, ForumSearch } from '../../utils/api/services/forum';
import paths from '../../paths';
import Preloader from '../../components/Preloader/Preloader';
import ForumCategoryItem from './ForumCategoryItem';
import Search from '../../components/Search/Search';
import ForumSearchBlock from './ForumSearchBlock';
import ListFooter from '../../components/ListFooter/ListFooter';
import { getQuery } from '../../utils/urlHelper';
import { setUrlParameters } from '../../utils/helpers';

export default class Forum extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    this.pageSize = 15;

    this.state = {
      searchQuery: '',
      requestedSearchQuery: '',
      showSearchResult: false,
      searchResult: [],
      searchTotal: 0,
      categories: [],
      page: 1,
    };
  }

  componentWillMount = () => {
    this.getForums();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.props.location.search = getQuery();
    if (prevProps.location.search !== this.props.location.search) {
      this.setState(
        {
          showSearchResult: false,
          searchQuery: '',
        },
        this.getForums(),
      );
    }
  }

  getForums = () => {
    this.setState({ isLoading: true });
    GetMainPage()
      .then((result) => {
        this.setState({
          categories: result,
        });
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  handleSearchQueryChange = (e) => {
    const searchQuery = e.currentTarget.value;
    this.setState({ searchQuery });
  };

  setResult = (more = false) => {
    const urlQuery = {};
    urlQuery.page = null;
    urlQuery.query = this.state.searchQuery;
    setUrlParameters(urlQuery, () => {
      if (this.state.showSearchResult) {
        this.search(
          this.state.searchQuery,
          'all',
          '',
          this.pageSize,
          (this.state.page - 1) * this.pageSize,
          more,
        );
      }
    });
  };

  search = (query, type, alias, take, skip, more) => {
    ForumSearch(query, type, alias, take, skip)
      .then((result) => {
        if (more) {
          this.setState({
            showSearchResult: true,
            requestedSearchQuery: query,
            searchResult: [...this.state.searchResult, ...result.data],
            searchTotal: result.total,
          });
        } else {
          this.setState({
            showSearchResult: true,
            searchResult: result.data,
            requestedSearchQuery: query,
            searchTotal: result.total,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          isLoadingMore: false,
        });
      });
  };

  handleSearch = () => {
    const { searchQuery, showSearchResult } = this.state;
    if (searchQuery && searchQuery.trim && searchQuery.trim().length) {
      this.setState(
        {
          showSearchResult: true,
          page: 1,
        },
        this.setResult,
      );
    } else if (showSearchResult) {
      this.setState(
        {
          showSearchResult: false,
          searchQuery: [],
          searchTotal: null,
          page: 1,
        },
        this.setResult,
      );
    }
  };

  handleSearchEnterPress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.handleSearch();
    }
  };

  handlePageClick = (e) => {
    const newPage = e.selected + 1;
    this.setState({ page: newPage }, this.setResult);
  };

  handleGetMoreTopics = () => {
    this.setState(
      {
        isLoadingMore: true,
        page: this.state.page + 1,
      },
      () => this.setResult(true),
    );
  };

  render() {
    const {
      searchQuery,
      isLoading,
      categories,
      requestedSearchQuery,
      showSearchResult,
      searchResult,
      searchTotal,
      page,
    } = this.state;
    return (
      <div className="b-center bg-dragonfly5">
        <BreadCrumbs
          data={[
            { url: paths.advocates.main, text: 'Главная' },
            { url: paths.advocates.forum, text: 'Форум' },
          ]}
        />
        <h1 className="title -third">Форум</h1>
        <Search
          placeholder="Поиск по форуму"
          searchQuery={searchQuery}
          handleSearch={this.handleSearch}
          handleSearchQueryChange={this.handleSearchQueryChange}
          handleSearchEnterPress={this.handleSearchEnterPress}
          renderSearchButton
        />

        {showSearchResult ? (
          <React.Fragment>
            <ForumSearchBlock searchQuery={requestedSearchQuery} searchResult={searchResult} />
            <ListFooter
              counterLabel="тем"
              pageSize={this.pageSize}
              total={searchTotal}
              handlePageClick={this.handlePageClick}
              handleLoadMore={this.handleGetMoreTopics}
              currentPage={page}
            />
          </React.Fragment>
        ) : (
          <div className="themes-list themes-list--all">
            {isLoading ? (
              <Preloader />
            ) : (
              categories.map(category => (
                <ForumCategoryItem key={category.id} category={category} />
              ))
            )}
          </div>
        )}
      </div>
    );
  }
}
